import React from "react";
import { ConfirmationDialog } from "../../../../components/Dialog/ConfirmationDialog";
import { SFDCIntegration } from "../../types";

interface DeleteIntegrationConfirmDialogProps {
  open: boolean;
  integration?: SFDCIntegration;
  onClose: () => void;
  onConfirm: () => void;
}

export const DeleteIntegrationConfirmDialog: React.FC<
  DeleteIntegrationConfirmDialogProps
> = ({ open, integration, onClose, onConfirm }) => {
  return (
    <ConfirmationDialog
      open={open}
      title="Delete Integration"
      description={`Are you sure you want to delete "${integration?.name || "this integration"}"? This action cannot be undone and will remove all associated data and settings.`}
      okayButtonText="Delete"
      cancelButtonText="Cancel"
      onClose={onClose}
      onConfirm={onConfirm}
    />
  );
};
